import './styles.scss'
import React, { useContext, useEffect, useState, useRef } from 'react'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { NavLink } from 'react-router-dom'
import { getLocalAppSettings, getLocalUserDetails } from 'Utils/LocalStorage_Handler'
import { CoffeeWebContext } from 'Context/CoffeeWebContext'
import { CoffeeWebWhiteLogoMask } from 'Assets/Icons'
import { ROUTE_STRINGS } from 'Utils/Constants'

const Menubar = () => {
  const location = useLocation()
  const userDetails = getLocalUserDetails()
  const appSettings = getLocalAppSettings()
  const { isLoading } = useContext(CoffeeWebContext)
  const dropdownRef = useRef(null)
  const params = new URLSearchParams(window.location.search)
  const tab = params.get('tab')
  const view = params.get('view')

  const [activeTab, setActiveTab] = useState(tab || 'business')

  const [isExploreOpen, setIsExploreOpen] = useState(false)

  // Helper function to determine which tab a route belongs to
  const getTabForCurrentRoute = () => {
    if (tab && tab === 'general') return 'general'

    const currentPath = location.pathname

    if (!userDetails?.businessGeneralMenus) return 'business'

    const businessMenus = userDetails.businessGeneralMenus?.businessMenu || []
    const generalMenus = userDetails.businessGeneralMenus?.generalMenu || []

    // Check if current route is in business menus
    const isInBusiness = businessMenus.some((menu) => currentPath.includes(menu.menuUrl))

    // Check if current route is in general menus
    const isInGeneral = generalMenus.some((menu) => currentPath.includes(menu.menuUrl))

    if (isInBusiness && isInGeneral) return activeTab
    if (isInBusiness) return 'business'
    if (isInGeneral) return 'general'

    // Default to business if route not found in either
    return 'business'
  }

  // Set active tab based on current route on mount (handles refresh)
  useEffect(() => {
    const tabForRoute = getTabForCurrentRoute()

    setActiveTab(tabForRoute)
  }, [location.pathname, location.search])

  useEffect(() => {
    if (appSettings?.showMenuBold === true) {
      document.documentElement.style.setProperty('--setFontWeight', 'bold')
    }

    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsExploreOpen(false)
      }
    }

    document.addEventListener('click', handleOutsideClick)

    return () => document.removeEventListener('click', handleOutsideClick)
  }, [])

  useEffect(() => {
    setIsExploreOpen(false)
  }, [location.pathname])

  // eslint-disable-next-line
  const transformMenuUrl = (url) => '/dashboard/' + url

  const parentMenuWithSubmenus = userDetails?.businessGeneralMenus?.businessMenu?.find((menu) => menu.subMenuModels?.length > 0 && menu?.menuUrl === 'menu')

  const coffeewebViewMenus = ['coffeecast', 'coffee-games', 'coffee-community', 'coffeecart', 'coffee-post', 'cafes']

  // Helper function to get the correct navigation URL for a menu
  const getMenuNavigationUrl = (menuUrl) => {
    // Check if this menu should use coffeeweb route with view params

    const normalizedMenuUrl = menuUrl?.replace(/^\//, '')?.toLowerCase()

    if (coffeewebViewMenus.includes(normalizedMenuUrl)) {
      return `${ROUTE_STRINGS.coffeeweb}?view=${normalizedMenuUrl}&tab=${activeTab}`
    }
    // For all other menus (including coffeewebAi), use normal route transformation

    // Handle coffeeweb menu itself - preserve tab parameter
    if (normalizedMenuUrl === 'coffeeweb') {
      // Navigate to coffeeweb with default view and preserve tab
      return `${ROUTE_STRINGS.coffeeweb}?view=${ROUTE_STRINGS.coffeePost}&tab=${activeTab}`
    }

    return transformMenuUrl(menuUrl)
  }

  const getFilteredMenus = () => {
    if (!userDetails?.businessGeneralMenus) return []

    if (activeTab === 'business') {
      return userDetails.businessGeneralMenus?.businessMenu || []
    }

    return userDetails.businessGeneralMenus?.generalMenu || []
  }

  const filteredMenus = getFilteredMenus()

  // Kept it for future reference
  // const handleTabSwitch = (tab) => {
  //   if (tab === activeTab) return // Don't do anything if clicking the same tab

  //   setActiveTab(tab)

  //   // Navigate to default route for the selected tab
  //   if (tab === 'business') {
  //     // Navigate to Coffee Quotes (first business menu item)
  //     const businessMenus = userDetails?.businessGeneralMenus?.businessMenu || []
  //     const coffeeQuotesMenu = businessMenus.find((menu) => menu.menuUrl === 'CoffeeQuotes')

  //     if (coffeeQuotesMenu) {
  //       history.push(transformMenuUrl(coffeeQuotesMenu.menuUrl))
  //     }
  //   } else if (tab === 'general') {
  //     // Navigate to Coffee Community (coffeeweb) using view param

  //     history.push(`${ROUTE_STRINGS.coffeeweb}?view=${ROUTE_STRINGS.coffeePost}&tab=general`)
  //   }
  // }

  return (
    <>
      {userDetails.userRole !== 5 && (
        <div className={`post_header ${isLoading ? 'is-loading' : ''}`} data-testid="menu-main-container">
          <div className="" id="navbar-main" data-testid="navbar-main-container">
            <div>
              <div aria-controls="basic-navbar-nav" />
              <div id="basic-navbar-nav" data-testid="basic-navbar-container">
                <ul className="navbar-nav" data-testid="navbar-ul-container">
                  {/* Main Menus */}
                  {filteredMenus !== null &&
                    filteredMenus
                      .filter((ele) => !userDetails?.menu?.some((sub) => sub.menuUrl === ele.menuUrl))
                      .map((ele, index) => (
                        <div key={index}>
                          {/* {ele.isWebDisplayEnable === true && ele.isLaunch === true && ele.menuUrl !== null && (
                            <li className="nav-item1 menucolor1" id="navitem" data-testid="navbar-li-container">
                              <NavLink activeClassName="active_nav-link1" exact to={transformMenuUrl(ele?.menuUrl)} className="nav-link1 nav-link-ltr">
                                <div className="menu-name-container" data-testid="menu-name-container">
                                  {ele?.menuIcon && <img src={ele.menuUrl === 'aboutUs' && !location.pathname?.includes(ROUTE_STRINGS.aboutUs) ? CoffeeWebWhiteLogoMask : ele?.menuIcon} alt="menu-image" className="menu-icon" />} {ele.menuName}
                                </div>
                              </NavLink>
                            </li>
                          )} */}
                          {ele.menuUrl === 'menu' ? null : (
                            <>
                              {ele.isWebDisplayEnable === true && ele.isLaunch === true && ele.menuUrl !== null && (
                                <li className="nav-item1 menucolor1" id="navitem" data-testid="navbar-li-container">
                                  <NavLink
                                    activeClassName="active_nav-link1"
                                    exact
                                    to={getMenuNavigationUrl(ele?.menuUrl)}
                                    className="nav-link1 nav-link-ltr"
                                    isActive={(match, location) => {
                                      const normalizedMenuUrl = ele?.menuUrl?.replace(/^\//, '')?.toLowerCase()

                                      // For coffeeweb view menus, check if we're on coffeeweb route with matching view param
                                      if (coffeewebViewMenus.includes(normalizedMenuUrl)) {
                                        const params = new URLSearchParams(location.search)
                                        const view = params.get('view')

                                        return location.pathname === ROUTE_STRINGS.coffeeweb && view?.toLowerCase() === normalizedMenuUrl
                                      }
                                      // For other menus, use default NavLink active matching

                                      return match !== null
                                    }}
                                  >
                                    <div className="menu-name-container" data-testid="menu-name-container">
                                      {ele?.menuIcon && <img src={ele.menuUrl === 'aboutUs' && !location.pathname?.includes(ROUTE_STRINGS.aboutUs) ? CoffeeWebWhiteLogoMask : ele?.menuIcon} alt="menu-image" className="menu-icon" />} {ele.menuName}
                                    </div>
                                  </NavLink>
                                </li>
                              )}
                            </>
                          )}
                        </div>
                      ))}

                  {/* Explore Dropdown Menu */}
                  {activeTab === 'business' && parentMenuWithSubmenus?.menuName && (
                    <li
                      className="nav-item1 menucolor1 dropdown-li-explore"
                      ref={dropdownRef}
                      onClick={(e) => {
                        e.stopPropagation()
                        setIsExploreOpen((prev) => !prev)
                      }}
                    >
                      <div className="nav-link1 dropdown-toggle" data-testid="explore-menu">
                        {parentMenuWithSubmenus?.menuName}
                        <i className="pi pi-bars"></i>
                      </div>
                      {isExploreOpen && (
                        <ul className="dropdown-menu-ul" data-testid="dropdown-menus">
                          {parentMenuWithSubmenus?.subMenuModels?.map((menu) => (
                            <li key={menu.id}>
                              <NavLink exact to={transformMenuUrl(menu.menuUrl)} className={`${view === 'coffee-post' && 'business-active-tab-navLink'} dropdown-item-navLink`} onClick={() => setIsExploreOpen(false)}>
                                <div className={`${view === 'coffee-post' && 'business-active-tab-content'} menu-dropdown-content`}>
                                  {menu.menuIcon && <img src={menu?.menuIcon} alt="menu-image" className="menu-icon" />}
                                  {menu.menuName}
                                </div>
                              </NavLink>
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Kept it for future reference */}
      {/* <div className={`business-general-container-menubar ${isLoading ? 'on-loading-z-index-business-general-container' : ''}`}>
        <div
          className={`business-container ${activeTab === 'business' ? 'active-tab' : ''}`}
          onClick={() => handleTabSwitch('business')}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault()
              handleTabSwitch('business')
            }
          }}
        >
          BUSINESS
        </div>
        <div
          className={`general-container ${activeTab === 'general' ? 'active-tab' : ''}`}
          onClick={() => handleTabSwitch('general')}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault()
              handleTabSwitch('general')
            }
          }}
        >
          GENERAL
        </div>
      </div> */}
    </>
  )
}

export default Menubar
